import { TenantPublicInfo } from "../models/tenant.model";

export enum TenantActionTypes {
  LOAD_TENANT_REQUEST = "[Tenant] Load Tenant Request",
  LOAD_TENANT_SUCCESS = "[Tenant] Load Tenant Success",
  LOAD_TENANT_FAILURE = "[Tenant] Load Tenant Failure",
  CLEAR_TENANT_ERROR = "[Tenant] Clear Error"
}

export interface LoadTenantRequestAction {
  type: TenantActionTypes.LOAD_TENANT_REQUEST;
}

export interface LoadTenantSuccessAction {
  type: TenantActionTypes.LOAD_TENANT_SUCCESS;
  payload: TenantPublicInfo;
}

export interface LoadTenantFailureAction {
  type: TenantActionTypes.LOAD_TENANT_FAILURE;
  payload: string;
}

export interface ClearTenantErrorAction {
  type: TenantActionTypes.CLEAR_TENANT_ERROR;
}

export type TenantActions = 
  | LoadTenantRequestAction
  | LoadTenantSuccessAction
  | LoadTenantFailureAction
  | ClearTenantErrorAction;

export const loadTenantRequest = (): LoadTenantRequestAction => ({
  type: TenantActionTypes.LOAD_TENANT_REQUEST
});

export const loadTenantSuccess = (tenant: TenantPublicInfo): LoadTenantSuccessAction => ({
  type: TenantActionTypes.LOAD_TENANT_SUCCESS,
  payload: tenant
});

export const loadTenantFailure = (error: string): LoadTenantFailureAction => ({
  type: TenantActionTypes.LOAD_TENANT_FAILURE,
  payload: error
});

export const clearTenantError = (): ClearTenantErrorAction => ({
  type: TenantActionTypes.CLEAR_TENANT_ERROR
}); 